import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';

import type { AppRouteContext } from '../../../app/routeContext';

type RequireAuthProps = {
  children?: ReactNode;
  redirectTo?: string;
};

export default function RequireAuth({ children, redirectTo = '/' }: RequireAuthProps) {
  const location = useLocation();
  const context = useOutletContext<AppRouteContext>();

  if (!context.core.currentUser) {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  return children ? <>{children}</> : <Outlet context={context} />;
}
